/**
 * Web3 Configuration for Honeyshares DApp
 * Mainnet deployment on Ethereum
 */

export const WEB3_CONFIG = {
  // Network Configuration
  CHAIN_ID: 1, // Ethereum Mainnet
  CHAIN_NAME: 'Ethereum Mainnet',
  RPC_URL: process.env.REACT_APP_RPC_URL || 'https://eth.llamarpc.com',
  
  // Contract Addresses (from deployments/mainnet-*.json)
  PROPERTY_TOKEN_ADDRESS: '0x8b33a83b2d6e3BC628DAe886E5215a54011C11ca',
  STAKING_VAULT_ADDRESS: '0xd7c2C144518d60f8A16BA6E0e802b8afF495EAd8',
  
  // Block Explorer
  EXPLORER_URL: 'https://etherscan.io',
  
  // Deployment Info
  DEPLOYMENT_BLOCK: 23464246,
  DEPLOYER_ADDRESS: '0x2516175F2C636aB7eE4681397727CE51FD5698AF',
};

// Helper functions
export const getExplorerAddressUrl = (address: string) =>
  `${WEB3_CONFIG.EXPLORER_URL}/address/${address}`;

export const getExplorerTxUrl = (txHash: string) =>
  `${WEB3_CONFIG.EXPLORER_URL}/tx/${txHash}`;

export const getExplorerTokenUrl = (tokenId: string) =>
  `${WEB3_CONFIG.EXPLORER_URL}/token/${WEB3_CONFIG.PROPERTY_TOKEN_ADDRESS}?a=${tokenId}`;
